// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_XWx5K","countdown":"index_countdown_ngCfW","voiceBtn":"index_voiceBtn_4NxYT","voiceBtnMuted":"index_voiceBtnMuted_zwdtH"};